import { call, put, takeLatest } from 'redux-saga/effects';

import { spacerUpdateError, spacerUpdateRequest, spacerUpdateStore } from './spacerActions.js';
import { updateSpacerApiCall } from './spacerAPI.js';

function* updateSpacerSaga({ payload }) {
  try {
    yield call(updateSpacerApiCall, payload);
    yield put(spacerUpdateStore());
  } catch (error) {
    yield put(spacerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsSpacerWatcher() {
  yield takeLatest(spacerUpdateRequest.type, updateSpacerSaga);
}
